import { createSelector } from "reselect";
import navigation from "../constants/navigation";

const puzzlesSelector = state => state.puzzles;
const routerSelector = state => state.router;
const uiSelector = state => state.ui;

export const shouldShowNav = createSelector(
  puzzlesSelector,
  puzzles =>
    puzzles.hasBypassedPuzzles ||
    puzzles.solvedPuzzles.length !== 0
);

function getActiveNavItem(router) {
  return Object.values(navigation).find(
    item => router.location.pathname.indexOf(item.path) !== -1
  );
}

export const activePuzzle = createSelector(
  routerSelector,
  router => (getActiveNavItem(router) || navigation["About"]).rune
);

export const shouldShowPad = createSelector(
  [puzzlesSelector, routerSelector],
  (puzzles, router) => {
    if (puzzles.hasBypassedPuzzles) return false;
    return (
      puzzles.solvedPuzzles.indexOf((getActiveNavItem(router) || {}).rune) ===
      -1
    );
  }
);

export const unlockedContent = createSelector(puzzlesSelector, puzzles => {
  const navigationItems = Object.values(navigation);
  if (puzzles.hasBypassedPuzzles) {
    return navigationItems
  }
  return puzzles.solvedPuzzles.map(rune => {
    return navigationItems.find(item => item.rune === rune);
  });
});

export const shouldShowBypass = createSelector(puzzlesSelector, puzzles => !puzzles.hasBypassedPuzzles)

export const isMenuOpen = createSelector(uiSelector, ui => ui.isMenuOpen);


// WEBPACK FOOTER //
// ./src/selectors/ui.js